
import styled from "styled-components";

export const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const Steps = styled.div`
  font-size: 14px;
`

export const Container = styled.div`
  padding: 0px 18px;
`

export const PreviewContainer = styled.div`
  border: 1px solid #E4E4E7;
  padding: 20px; 
  background-color: #F8FAFC;
  border-radius: 8px
`

export const PreviewDetail = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  gap: 4px;
`

export const PreviewDetailTitle = styled.p`
  font-weight: 600;
  margin: 0px;
  flex-shrink: 0;
`

export const PewviewDetailsDescription = styled.p`
  margin: 0px;
`

export const Circle = styled.div`
  flex-shrink: 0;
  width: 30px;
  height: 30px;
  border-radius: 100%;
  background-color: #ECE9FC;
  display: flex;
  align-items: center;
  justify-content: center;
`